import { z } from 'zod';
// Voice session validation schemas
export const createVoiceSessionSchema = z.object({
    inventoryId: z.string().uuid(),
});
export const voiceSessionStatusSchema = z.enum([
    'active',
    'processing',
    'completed',
    'failed',
    'cancelled',
]);
// Function call from Realtime API
export const functionCallSchema = z.object({
    name: z.string(),
    arguments: z.string(), // JSON string
    callId: z.string(),
});
// Function result to send back
export const functionResultSchema = z.object({
    callId: z.string(),
    result: z.unknown(),
});
//# sourceMappingURL=voice-session.js.map